shadow$provide[130] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Api:{enumerable:true, get:function() {
  return require$_DOT__SLASH_api_DOT_js.Api;
}}, Binder:{enumerable:true, get:function() {
  return require$_DOT__SLASH_binder_DOT_js.Binder;
}}, Bootstrap:{enumerable:true, get:function() {
  return require$_DOT__SLASH_bootstrap_DOT_js.Bootstrap;
}}, MultiRenderer:{enumerable:true, get:function() {
  return require$_DOT__SLASH_renderers_SLASH_MultiRenderer_DOT_js.MultiRenderer;
}}, VRControls:{enumerable:true, get:function() {
  return require$_DOT__SLASH_controls_SLASH_VRControls_DOT_js.VRControls;
}}, VRRenderer:{enumerable:true, get:function() {
  return require$_DOT__SLASH_renderers_SLASH_VRRenderer_DOT_js.VRRenderer;
}}});
var require$_DOT__SLASH_aliases = require("./aliases");
var require$_DOT__SLASH_binder = require("./binder");
var require$_DOT__SLASH_bootstrap = require("./bootstrap");
var require$_DOT__SLASH_core = require("./core");
var require$_DOT__SLASH_extra = require("./extra");
var require$_DOT__SLASH_controls = require("./controls");
var require$_DOT__SLASH_renderers = require("./renderers");
var require$_DOT__SLASH_api_DOT_js = require("./api.js");
var require$_DOT__SLASH_binder_DOT_js = require("./binder.js");
var require$_DOT__SLASH_bootstrap_DOT_js = require("./bootstrap.js");
var require$_DOT__SLASH_controls_SLASH_VRControls_DOT_js = require("./controls/VRControls.js");
var require$_DOT__SLASH_renderers_SLASH_MultiRenderer_DOT_js = require("./renderers/MultiRenderer.js");
var require$_DOT__SLASH_renderers_SLASH_VRRenderer_DOT_js = require("./renderers/VRRenderer.js");

};